import { Link } from 'react-router-dom'
import { SearchIcon } from '@/components/ui/icons'
import { EmptyState, LinkButton } from '@/components/ui/primitives'

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-24">
      <EmptyState
        icon={<SearchIcon size={20} />}
        title="Page not found"
        description={
          <>
            That address does not exist. If you followed a link to a business that was
            merged into another record, the redirect should have taken you there —{' '}
            <Link to="/methodology#corrections" className="underline">
              let us know
            </Link>{' '}
            if it did not.
          </>
        }
        action={<LinkButton to="/" size="sm">Back to search</LinkButton>}
      />
    </div>
  )
}
